/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CreateSubscriptionRequest as BackendCoreApiModelsAppOrganizationCreateSubscriptionRequest } from '../models/Backend/Core/Api/Models/App/Organization/create-subscription-request';
import { RemoveSubscriptionRequest as BackendCoreApiModelsAppOrganizationRemoveSubscriptionRequest } from '../models/Backend/Core/Api/Models/App/Organization/remove-subscription-request';
import { SubscriptionCollectionRequest as BackendCoreApiModelsAppOrganizationSubscriptionCollectionRequest } from '../models/Backend/Core/Api/Models/App/Organization/subscription-collection-request';
import { SubscriptionCollectionResponse as BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse } from '../models/Backend/Core/Api/Models/App/Organization/subscription-collection-response';
import { SubscriptionRegistrationRequest as BackendCoreApiModelsAppOrganizationSubscriptionRegistrationRequest } from '../models/Backend/Core/Api/Models/App/Organization/subscription-registration-request';
import { UpdateSubscriptionRequest as BackendCoreApiModelsAppOrganizationUpdateSubscriptionRequest } from '../models/Backend/Core/Api/Models/App/Organization/update-subscription-request';
import { SimpleResponse as SharedKernelModelsSimpleResponse } from '../models/SharedKernel/Models/simple-response';

@Injectable({
  providedIn: 'root',
})
export class SubscriptionBackendService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation createSubscription
   */
  static readonly CreateSubscriptionPath = '/api/subscription/create';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscription$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSubscription$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationCreateSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.CreateSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createSubscription$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSubscription$Plain(params?: {
    body?: BackendCoreApiModelsAppOrganizationCreateSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createSubscription$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSubscription$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSubscription$Json$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationCreateSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.CreateSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createSubscription$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  createSubscription$Json(params?: {
    body?: BackendCoreApiModelsAppOrganizationCreateSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.createSubscription$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation removeSubscription
   */
  static readonly RemoveSubscriptionPath = '/api/subscription/remove';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSubscription$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeSubscription$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationRemoveSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.RemoveSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeSubscription$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeSubscription$Plain(params?: {
    body?: BackendCoreApiModelsAppOrganizationRemoveSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeSubscription$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeSubscription$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeSubscription$Json$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationRemoveSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.RemoveSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `removeSubscription$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  removeSubscription$Json(params?: {
    body?: BackendCoreApiModelsAppOrganizationRemoveSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.removeSubscription$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation getSubscriptions
   */
  static readonly GetSubscriptionsPath = '/api/subscription/list';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptions$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSubscriptions$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationSubscriptionCollectionRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.GetSubscriptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubscriptions$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSubscriptions$Plain(params?: {
    body?: BackendCoreApiModelsAppOrganizationSubscriptionCollectionRequest
  }): Observable<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse> {

    return this.getSubscriptions$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>) => r.body as BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSubscriptions$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSubscriptions$Json$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationSubscriptionCollectionRequest
  }): Observable<StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.GetSubscriptionsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSubscriptions$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  getSubscriptions$Json(params?: {
    body?: BackendCoreApiModelsAppOrganizationSubscriptionCollectionRequest
  }): Observable<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse> {

    return this.getSubscriptions$Json$Response(params).pipe(
      map((r: StrictHttpResponse<BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse>) => r.body as BackendCoreApiModelsAppOrganizationSubscriptionCollectionResponse)
    );
  }

  /**
   * Path part for operation register
   */
  static readonly RegisterPath = '/api/subscription/register';

  /**
   * Create a new subscription and register a new user as a SubscriptionAdministrator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register$Plain$Response(params: {
    body: BackendCoreApiModelsAppOrganizationSubscriptionRegistrationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.RegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Create a new subscription and register a new user as a SubscriptionAdministrator.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `register$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register$Plain(params: {
    body: BackendCoreApiModelsAppOrganizationSubscriptionRegistrationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.register$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Create a new subscription and register a new user as a SubscriptionAdministrator.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `register$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register$Json$Response(params: {
    body: BackendCoreApiModelsAppOrganizationSubscriptionRegistrationRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.RegisterPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Create a new subscription and register a new user as a SubscriptionAdministrator.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `register$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  register$Json(params: {
    body: BackendCoreApiModelsAppOrganizationSubscriptionRegistrationRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.register$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation sendMessage
   */
  static readonly SendMessagePath = '/api/subscription/send-message';

  /**
   * Sends a message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendMessage$Plain()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendMessage$Plain$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.SendMessagePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Sends a message.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendMessage$Plain$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendMessage$Plain(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.sendMessage$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Sends a message.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `sendMessage$Json()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendMessage$Json$Response(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.SendMessagePath, 'post');
    if (params) {
      rb.body(params.body, 'multipart/form-data');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * Sends a message.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `sendMessage$Json$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  sendMessage$Json(params?: {
    body?: {

/**
 * Title
 */
'Title': string;

/**
 * Text
 */
'Text': string;
'Attachment'?: Blob;

/**
 * Unique Identifier used by logging
 */
'CorrelationId'?: string;
}
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.sendMessage$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * Path part for operation updateSubscription
   */
  static readonly UpdateSubscriptionPath = '/api/subscription/update';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscription$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubscription$Plain$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationUpdateSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.UpdateSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: 'text/plain'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSubscription$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubscription$Plain(params?: {
    body?: BackendCoreApiModelsAppOrganizationUpdateSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateSubscription$Plain$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSubscription$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubscription$Json$Response(params?: {
    body?: BackendCoreApiModelsAppOrganizationUpdateSubscriptionRequest
  }): Observable<StrictHttpResponse<SharedKernelModelsSimpleResponse>> {

    const rb = new RequestBuilder(this.rootUrl, SubscriptionBackendService.UpdateSubscriptionPath, 'post');
    if (params) {
      rb.body(params.body, 'application/*+json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'text/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SharedKernelModelsSimpleResponse>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateSubscription$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateSubscription$Json(params?: {
    body?: BackendCoreApiModelsAppOrganizationUpdateSubscriptionRequest
  }): Observable<SharedKernelModelsSimpleResponse> {

    return this.updateSubscription$Json$Response(params).pipe(
      map((r: StrictHttpResponse<SharedKernelModelsSimpleResponse>) => r.body as SharedKernelModelsSimpleResponse)
    );
  }

}
